









































import { Component } from 'vue-property-decorator'
import { EliteligaMediathek } from '@russmedia-frontend/nordstern-eliteliga'
import type { SoccerLeague } from '@russmedia-frontend/nordstern-eliteliga'
import EliteligaFeature from '~base/mixins/EliteligaFeature'
import VNEliteliga from '~components/assets/VNEliteliga.vue'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'
import SoccerLeagueButtons from '~components/content/widgets/listings/SoccerLeagueButtons.vue'
import VideoModal from '~components/eliteliga/VideoModal.vue'

import '@russmedia-frontend/nordstern-eliteliga/nordstern-eliteliga.css'

@Component({
  components: {
    VNEliteliga,
    RessortTitle,
    EliteligaMediathek,
    VideoModal,
    SoccerLeagueButtons,
  },
  apollo: {
    multipastgames: {
      query: require('~base/graphql/queries/FetchDataForMediathek.gql'),
      variables() {
        return {
          leagues: this.leagues,
          season: this.season === null ? undefined : parseInt(this.season),
        }
      },
    },
    multileague: {
      query: require('~base/graphql/queries/FetchUpcomingForMediathek.gql'),
      variables() {
        return {
          leagues: this.leagues,
        }
      },
    },
  },
})
export default class EliteligaMediathekPage extends EliteligaFeature {
  private multipastgames: SoccerLeague[] = []
  private multileague: SoccerLeague[] = []
  private team: string | null = null
  protected season: string | null = null

  leagues = ['Eliteliga_Grunddurchgang', 'RLW']

  onSeasonChange(val: string) {
    this.season = `${val}`
  }
}
